import { render, staticRenderFns } from "./priceUpdates.vue?vue&type=template&id=6f253e0d"
import script from "./priceUpdates.vue?vue&type=script&lang=js"
export * from "./priceUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports